import React from 'react';
import { Button } from '@wds/button';

import { CTA_LABEL } from '~pricing/lib/summaryPackages';
import { PACKAGE_IDS } from '~pricing/lib/constants';

import useStyles from './useStyles';
import getCTAText from './getCTAOptions';

type PackageCTAProps = {
  ctaLabel: keyof typeof CTA_LABEL;
  packageName: string;
  small?: boolean;
};

const PackageCta = ({ ctaLabel, packageName, small = false }: PackageCTAProps): JSX.Element => {
  const { CTA, noCTA } = useStyles({ packageName });
  const packageId = PACKAGE_IDS[packageName];
  const { url, text, disabled } = getCTAText({ packageId, ctaLabel });

  return (
    <div className={disabled ? noCTA : CTA}>
      <Button
        href={url}
        stretched
        variant={disabled ? 'text' : 'solid'}
        disabled={disabled}
        data-testid="PackageCta__Btn"
        size={small ? 'sm' : 'md'}
      >
        {text}
      </Button>
    </div>
  );
};

export default PackageCta;
